import React, { Component, useRef, useState } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import Profile_img from './../../assets/images/user-male.png';
// import SelectField from 'material-ui/SelectField';
// import MenuItem from 'material-ui/MenuItem';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import $ from 'jquery';
import 'react-datepicker/dist/react-datepicker.css'
import AutoComplete from 'material-ui/AutoComplete';
import CAutocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { getDefaultData } from '../../actions/manageEmployeeAction';
import { insertEmployee } from '../../actions/addEmployeeAction';
import { connect } from "react-redux";
import * as actionFunction from "../../actions/common";
import { withStyles } from "@material-ui/core/styles";
// import TextField from '@material-ui/core/TextField';
import { TextField } from '@material-ui/core';

const selected_permission = [];
const CustomAutocomplete = withStyles({
	root: {
		fontFamily: "Poppins-Regular",
		padding: "0px 8px",
		"& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
			// Default transform is "translate(14px, 20px) scale(1)""
			// This lines up the label with the initial cursor position in the input
			// after changing its padding-left.
			transform: "translate(34px, 20px) scale(1);"
		}
	},
	inputRoot: {
		color: "#555",
		border: "1",
		borderColor: "#DBE1EA",
		fontFamily: "Poppins-Regular",
		fontSize: "12px",
		// This matches the specificity of the default styles at https://github.com/mui-org/material-ui/blob/v4.11.3/packages/material-ui-lab/src/Autocomplete/Autocomplete.js#L90
		'&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
			// Default left padding is 6px
			paddingLeft: 0
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "#DBE1EA"
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "#DBE1EA"

		},
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "#DBE1EA",
			border: "1px solid",
		}
	},
	listbox: {
		fontFamily: "Poppins-Regular",
		fontSize: "12px",
	},
	popupIndicator: {
		display: "none",
	},
	tag: {
		backgroundColor: "#F1FCFF",
		borderColor: '#D9F6FD',
		border: "1px solid",
		fontFamily: "Poppins-Regular",
		fontSize: "12px",
		lineHeight: "18px",
		height: 24,
		borderRadius: "4px",
		position: "relative",
		zIndex: 0,
		"& .MuiChip-label": {
			color: "#86979C"
		},
		"& .MuiChip-deleteIcon": {
			color: "#d1d1d1bf"
		},
		"&:after": {
			content: '""',
			right: 10,
			top: 6,
			height: 12,
			width: 12,
			position: "absolute",
			backgroundColor: "white",
			zIndex: -1
		}
	}
})(CAutocomplete);
const dataSourceConfig = {
	text: 'title',
	value: 'id',
};
// const selected_group_id = [];
// const selected_group_listener = [];
// const selected_pod = [];
// const selected_corp = [];
// const selected_primary = [];
// const selected_listener = [];
// const selected_department = [];
class AddEmployee extends Component {
	constructor() {
		super();
		var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
		var localdata = has_local_data
		? actionFunction.decrypt(localStorage.getItem("encdata"), 0)
		: "";
		this.state = {
			permissions: [],
			// groups: [],
			manager_user: [],
			hiring_profile: [],
			// pod: [],
			//			team: [],
			// email_groups: [],
			isChecked: true,
			hierarchy_level: '0',
			marital_status: '0',
			religion: '0',
			// department: '',
			assign_to_title: '',
			assign_to_title1: '',
			name: '',
			date_of_joining: new Date(),
			date_of_previousexp: '',
			date_of_birth: '',
			fields: {},
			stateChange: {},
			itemchecked: {},
			roles: {},
			errors: {},
			//registered_mail: '',
			//registred_member:'',
			group_state: '1',
			search: [],
			manager: '',
			employee_role: [],
			// pod_names: [],
			// crop_names: [],
			// group_email: [],
			// selected_group_id: '',
			// selected_group_listener: '',
			// department_names: [],
			// troop_names: [],
			// email_names: [],
			// selected_pod: [],
			// selected_corp: [],
			selected_permission: [],
			// group: [],
			//ER:116571
			countries: [],
			states: [],
			cities: [],
			selectedCountry: '',
			selectedState: '',
			selectedCity: '',
			selectedEmrCountry: '',
			selectedEmrState: '',
			selectedEmrCity: '',
			emrcities: [],
			emrcountries: [],
			emrstates: [],
			hr_permission: "",
			apiUrl: actionFunction.decryptconfigdata("apiUrl"),
			userAuthKey: has_local_data ? localdata.user_key : "",
			userId: has_local_data ? localdata.user_id : "",
			userEmail: has_local_data ? localdata.user_email : "",
		};
		this.insertEmployee = this.insertEmployee.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onProjectChange = this.onProjectChange.bind(this);
		this.handleChangeDateOfJoining = this.handleChangeDateOfJoining.bind(this);

		this.handleChangeDateOfBirth = this.handleChangeDateOfBirth.bind(this);
		//		this.onPODChange = this.onPODChange.bind(this);
		// this.handleGroupChange = this.handleGroupChange.bind(this);
		// this.handleListenerGroupChange = this.handleListenerGroupChange.bind(this);
		//		this.onTeamChange = this.onTeamChange.bind(this);
		//		this.onEmailGroupChange = this.onEmailGroupChange.bind(this);
		//		this.onEmailGroupChange_list = this.onEmailGroupChange_list.bind(this);
		this.handlePermissionChange = this.handlePermissionChange.bind(this);
	}

	userList() {
		fetch(
			this.state.apiUrl +
			"/adminRest/GetCommonData/userAuthKey/" +
			this.state.userAuthKey +
			"/userId/" +
			this.state.userId,
			{
				method: "POST",
				dataType: "json",
				body: JSON.stringify(this.state),
			}
		)
		.then((Response) => Response.json())
		.then((findresponse) => {
			findresponse = actionFunction.decrypt(findresponse, 1);
			try {
				this.setState({
					hr_permission: findresponse.hr_permission,
					hr_snippet: findresponse.hr_snippet,
					quiz_expire_status: findresponse.quiz_expire_status,
					quiz_title: findresponse.quiz_title,
				});
			} catch (err) {
				console.log("err", err);
			}
		});
	}

	fileSelecthandler = (event) => {
		this.setState({ selectedFile: event.target.files[0] });
	}

	getManager(searchText1 = '') {
		var commonStateData = actionFunction.commonData()
		fetch(commonStateData.apiUrl + '/employee/getmanager/userAuthKey/' + commonStateData.userAuthKey + '/searchText/' + searchText1, {
			method: 'POST',
			dataType: 'json',
			body: JSON.stringify(this.state),
		}).then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = actionFunction.decrypt(findresponse, 1);
				if (findresponse.code == 200) {
					this.setState({
						search: findresponse.assign_to,
						errorText1: '',
						errorText2: ''
					})
				} else {
					this.setState({ errorText1: findresponse.msg, errorText2: findresponse.msg })
				}
			})
	}
	getManager_func(searchText1 = '') {
		var commonStateData = actionFunction.commonData()
		fetch(commonStateData.apiUrl + '/employee/getManager/userAuthKey/' + commonStateData.userAuthKey + '/searchText/' + searchText1, {
			method: 'POST',
			dataType: 'json',
			body: JSON.stringify(this.state),
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = actionFunction.decrypt(findresponse, 1);
				if (findresponse.code == 200) {
					this.setState({
						search: findresponse.assign_to,
						errorText2: ''
					})
				} else {
					this.setState({ errorText2: findresponse.msg })
				}

			})
	}

	handleUpdateInput_manager = (searchText1) => {
		if (typeof searchText1 !== "string") {
			//check autocomplete is blank or having value?if not having value make it blank
			if (this.state.assign_to_title) {
				searchText1 = this.state.assign_to_title;
			} else {
				searchText1 = '';
			}
		}
		if (searchText1 == "") {
			this.setState({
				assign_to_title: ""
			})
		}
		this.setState({
			searchText1: searchText1,
		});
		this.getManager(searchText1);
	};

	handleUpdateInput_func_manager = (searchText2) => {
		if (typeof searchText2 !== "string") {
			//check autocomplete is blank or having value?if not having value make it blank
			if (this.state.assign_to_title1) {
				searchText2 = this.state.assign_to_title1;
			} else {
				searchText2 = '';
			}
		}
		if (searchText2 == "") {
			this.setState({
				assign_to_title1: ""
			})
		}
		this.setState({
			searchText2: searchText2,
		});
		this.getManager_func(searchText2);
	};
	/*getEmployeeList(){
		var commonStateData = actionFunction.commonData()
		fetch(commonStateData.apiUrl + '/HrmanagementRest/GetAllEmployees/userAuthKey/' + commonStateData.userAuthKey, {
			method: 'POST',
			dataType: 'json'
		})
			.then((Response) => Response.json())
			.then((findresponse) => {
				findresponse = actionFunction.decrypt(findresponse, 1);
				
			this.setState({
				department_names: findresponse.department_names,
				pod_names: findresponse.pod_names,
				crop_names: findresponse.crop_names,
				email_names: findresponse.group_email,
				troop_names: findresponse.troop_names
			})
		})
	}	*/


	/*handlePodChange = (selectedPodList) => {
		this.setState({
			selected_pod_members: selectedPodList,
			waiting:'',
		 }, function () {
		    
		});
		selected_pod.push(selectedPodList);
		this.handlePrimaryChange(selectedPodList);
	}*/
	ClosePermission = (a) => {
		const new_permissions = this.state.selected_permission.filter((element) => element.id !== a.id);
		this.setState({ selected_permission: new_permissions })
		return { code: 200, message: 'Permissions removed successfully' };
	}
	handlePermissionChange = (event, index) => {
		var value = event.target.value;
		if (event.target.value != '') {
			var strArray = value.split("/");
			var object = { 'id': strArray[0], 'name': strArray[1] };
			selected_permission.push(object);
			this.setState({ selected_permission: selected_permission })
		}
	}
	addPermissions = async (permissions) => {
		if (permissions && permissions.length <= 0) {
			return { code: 400, message: 'No permission to add' };
		}

		const new_permissions = [...this.state.selected_permission, ...permissions];
		this.setState({ selected_permission: new_permissions })
		return { code: 200, message: 'Permissions added successfully' };
	}

	onNewRequest_manager(chosenRequest, index) {
		this.setState({
			manager: chosenRequest.id,
			assign_to_title: chosenRequest.title
		})
	}
	onNewRequest_func_manager(chosenRequest, index) {
		this.setState({
			func_manager: chosenRequest.id,
			assign_to_title1: chosenRequest.title
		})
	}

	handleChangeDateOfJoining(date) {
		this.setState({ date_of_joining: date });
	}
	handleChangeDateOfBirth(date) {
		this.setState({
			dateofBirth: date,
			date_of_birth: moment(date).format("YYYY-MM-D")
		});
	}

	handleValidation() {
		let fields = this.state.fields;
		let errors = {};
		let formIsValid = true;
		if (!fields["name"]) {
			formIsValid = false;
			errors["name"] = "This field is required.";
		}
		if (!fields["position"]) {
			formIsValid = false;
			errors["position"] = "This field is required.";
		}
		{/*if (!fields["muvi_employee_id"]) {
			formIsValid = false;
			errors["muvi_employee_id"] = "This field is required.";
		}*/}
		if (!fields["email"]) {
			formIsValid = false;
			errors["email"] = "This field is required.";
		}

		if (!fields["linkedin_url"]) {
			formIsValid = false;
			errors["linkedin_url"] = "This field is required.";
		}

		// if (!fields["project"]) {
		// 	formIsValid = false;
		// 	errors["project"] = "This field is required.";
		// }
		if (this.state.selected_permission == '') {
			formIsValid = false;
			errors["project"] = "This field is required.";
		}
		// if (!this.state.department) {
		// 	formIsValid = false;
		// 	errors["department"] = "This field is required.";
		// }
		if (!this.state.manager) {
			formIsValid = false;
			errors["manager"] = "This field is required.";
		}
		if (!fields["emp_level"]) {
			formIsValid = false;
			errors["emp_level"] = "This field is required.";
		}
		/*if (!this.state.dateofBirth) {
			formIsValid = false;
			errors["date_of_birth"] = "This field is required.";
		}
		if (!fields["per_phoneno"]) {
			formIsValid = false;
			errors["per_phoneno"] = "This field is required.";
		} */
		if (fields["email"] && !this.isValidEmailAddress(fields["email"])) {
			formIsValid = false;
			errors["email"] = "Please Provide Correct Email.";
		}
		if (fields["email"]) {
			var str = fields["email"];
			var res = str.match('@muvi.com');
			if (!res) {
				formIsValid = false;
				errors["email"] = "Should be domain muvi.com.";
			}
		}

		const pattern = /^Muv \d+$/;
		if (!pattern.test(fields["muvi_employee_id"])) {
			formIsValid = false;
			errors["muvi_employee_id"] = "Invalid Muvi Employee ID format. It should start with 'Muv' followed by a space and digits.";
		}

		if (fields["per_email"] && !this.isValidEmailAddress(fields["per_email"])) {
			formIsValid = false;
			errors["per_email"] = "Please Provide Correct Email.";
		}
		if (fields["emr_phone_no"] && !this.isValidNumber(fields["emr_phone_no"])) {
			formIsValid = false;
			errors["emr_phone_no"] = "Please Provide Numbers Only.";
		}
		if (fields["emr_zipcode"] && !this.isValidNumber(fields["emr_zipcode"])) {
			formIsValid = false;
			errors["emr_zipcode"] = "Please Provide Numbers Only.";
		}
		if (fields["per_phoneno"] && !this.isValidNumber(fields["per_phoneno"])) {
			formIsValid = false;
			errors["per_phoneno"] = "Please Provide Numbers Only.";
		}
		if (fields["per_phoneno"]) {
			var mob = fields["per_phoneno"];
			if ((!mob) || (mob.length < 10)) {
				formIsValid = false;
				errors["per_phoneno"] = "Please enter 10 digit numbers.";
			}
		}
		if (fields["per_zipcode"] && !this.isValidNumber(fields["per_zipcode"])) {
			formIsValid = false;
			errors["per_zipcode"] = "Please Provide Numbers Only.";
		}
		this.setState({ errors: errors });
		return formIsValid;
	}

	isValidEmailAddress(emailAddress) {
		var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
		return pattern.test(emailAddress);
	}

	isValidNumber(number) {
		var pattern = /^[0-9]+$/;
		return pattern.test(number);
	}

	onProjectChange(event) {
		let fields = this.state.fields;
		this.setState({ [event.target.name]: event.target.value });
		fields[event.target.name] = event.target.value;
		var role = document.getElementsByName('project');
		this.state.roles = '';
		for (let i = 0; i < role.length; i++) {
			if (role[i].checked === true) {
				this.state.roles += role[i].value + ",";
			}
		}
	}
	onChange(event) {
		if (event.target.name == 'muvi_employee_id') {
			if (this.state.hr_permission != 'yes') {
				return;
			}

			let errors = this.state.errors;
			
			const value = event.target.value;
			const pattern = /^Muv \d+$/;

			if (!pattern.test(value)) {
				errors["muvi_employee_id"] = "Invalid Muvi Employee ID format. It should start with 'Muv' followed by a space and digits.";
			} else {
				errors["muvi_employee_id"] = "";
			}
			this.setState({ errors: errors });
		}

		let fields = this.state.fields;
		this.setState({ [event.target.name]: event.target.value });
		fields[event.target.name] = event.target.value;
	}

	insertEmployee(e) {
		var commonStateData = actionFunction.commonData()
		if (this.handleValidation()) {
			console.log("Data Has been submitted");
			//return true;
		} else {
			console.log("This Fields Are required.")
			return false;
		}
		document.getElementById("add_employee").innerHTML = "Sending....";
		let img = document.getElementById('imgInp').files.length;
		let pan_img = document.getElementById('pan_img').files.length;
		let passport_img = document.getElementById('passport_img').files.length;
		let adhar_img = document.getElementById('adhar_img').files.length;

		const post = {
			Employee: this.state,
			employee_id: this.state.fields['muvi_employee_id'],
			image: this.imgInp.files[0],
			pan_image: this.pan_img.files[0],
			pass_image: this.passport_img.files[0],
			adhar_iamgage: this.adhar_img.files[0]
		}
		this.props.insertEmployee(post)
		console.log(this.props.submit_sucsess);
		// if(this.props.submit_sucsess!=1){
		document.getElementById("add_employee").innerHTML = "Submit";
		// }
	}

	componentDidMount() {
		this.fetchCountries()
			.then((countries) => {
				console.log({ countries });
				this.setState({ countries, emrcountries: countries });
			})
			.catch((error) => {
				console.error("Error in fetch country:", error);
			});
		if (!localStorage.getItem('userLogin')) {
			this.setState({ redirect: true });
		}
		var page = 1
		const post = {
			page: page
		}
		this.userList();
		//console.log(this.props.loading);
		this.props.getDefaultData(post);
		//		this.getEmployeeList();
		window.addEventListener("keydown", function (e) {
			if (["ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
				e.preventDefault();
			}
		}, false);

		$(document).ready(function () {
			function readURL(input) {
				if (input.files && input.files[0]) {
					var reader = new FileReader();

					reader.onload = function (e) {
						$('#blah').attr('src', e.target.result);
					}

					reader.readAsDataURL(input.files[0]);
				}
			}
			$("#image-preview i").on('click', function () {
				$("#image-preview input").click();
			});
			$(".perso_id i").on('click', function () {
				$(this).parent().find('input').click();
			});

			$('.perso_id input[type="file"]').change(function (e) {
				var fileName = e.target.files[0].name;
				$(this).parent().closest('.perso_upload').find('.perso_text').html(fileName);
			});


			$('.inputfile').each(function () {
				var $input = $(this),
					$label = $input.next('label'),
					labelVal = $label.html();

				$input.on('change', function (e) {
					var fileName = '';
					if (this.files && this.files.length > 1)
						fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
					else if (e.target.value)
						fileName = e.target.value.split('\\').pop();

					if (fileName)
						$label.find('span').html(fileName);
					else
						$label.html(labelVal);
				});
			});
			$("#imgInp").change(function () {
				readURL(this);
			});
		});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.employee_id !== this.props.employee_id && this.props.employee_id) {
			let fields = this.state.fields;
			this.setState({ ['muvi_employee_id']: this.props.employee_id });
			fields['muvi_employee_id'] = this.props.employee_id;
		}
	}

	// ER:116571
	fetchCountries = async () => {
		try {
			const response = await fetch('https://api.countrystatecity.in/v1/countries', {
				headers: {
					'X-CSCAPI-KEY': 'bnpQUTF2TnNOYnZFQXJvRU9YRkhSMjFLUnBFZGI2ejhjaDhhcDNpQQ==',
				}
			});
			const countries = await response.json();
			// this.setState({ countries });
			return countries;
		} catch (error) {
			console.error("Error fetching countries:", error);
		}
	};

	fetchStates = async (countryCode) => {
		try {
			const response = await fetch(`https://api.countrystatecity.in/v1/countries/${countryCode}/states`, {
				headers: {
					'X-CSCAPI-KEY': 'bnpQUTF2TnNOYnZFQXJvRU9YRkhSMjFLUnBFZGI2ejhjaDhhcDNpQQ==',
				}
			});
			const states = await response.json();
			// this.setState({ states, cities: [], });
			return states;
		} catch (error) {
			console.error("Error fetching states:", error);
		}
	};

	fetchCities = async (countryCode, stateCode) => {
		try {
			const response = await fetch(`https://api.countrystatecity.in/v1/countries/${countryCode}/states/${stateCode}/cities`, {
				headers: {
					'X-CSCAPI-KEY': 'bnpQUTF2TnNOYnZFQXJvRU9YRkhSMjFLUnBFZGI2ejhjaDhhcDNpQQ==',
				}
			});
			const cities = await response.json();
			// this.setState({ cities, });
			return cities;
		} catch (error) {
			console.error("Error fetching cities:", error);
		}
	};

	handleCountryChange = async (e) => {
		let states = [];
		const selectedCountry = e.target.value;
		const Country = this.state.countries.find(country => country.iso2 === selectedCountry);
		console.log({ selectedCountry, per_country: Country.name })
		if (selectedCountry) {
			states = await this.fetchStates(selectedCountry);
		} else {
			this.setState({ states: [], cities: [], selectedState: '', selectedCity: '' });
		}
		this.setState({ selectedCountry, per_country: Country.name, states: states, selectedState: '', selectedCity: '' });
	};

	handleStateChange = async (e) => {
		let cities = [];
		const selectedState = e.target.value;
		const State = this.state.states.find(state => state.iso2 === selectedState);
		if (selectedState) {
			cities = await this.fetchCities(this.state.selectedCountry, selectedState);
		} else {
			this.setState({ cities: [], selectedCity: '' });
		}
		this.setState({ selectedState, per_state: State.name, cities: cities, selectedCity: '' });
	};

	handleCityChange = (e) => {
		this.setState({ selectedCity: e.target.value, per_city: e.target.value });
	};

	handleEmrCountryChange = async (e) => {
		let states = [];
		const selectedEmrCountry = e.target.value;
		const Country = this.state.emrcountries.find(country => country.iso2 === selectedEmrCountry);
		console.log({ selectedEmrCountry, per_country: Country.name })

		if (selectedEmrCountry) {
			states = await this.fetchStates(selectedEmrCountry);
		} else {
			this.setState({ emrstates: [], emrcities: [], selectedEmrState: '', selectedEmrCity: '' });
		}
		this.setState({ selectedEmrCountry, emr_country: Country.name, emrstates: states, selectedEmrState: '', selectedEmrCity: '' });
	};

	handleEmrStateChange = async (e) => {
		let cities = [];
		const selectedEmrState = e.target.value;
		const State = this.state.emrstates.find(state => state.iso2 === selectedEmrState);

		if (selectedEmrState) {
			cities = await this.fetchCities(this.state.selectedEmrCountry, selectedEmrState);
		} else {
			this.setState({ emrcities: [], selectedEmrCity: '' });
		}
		this.setState({ selectedEmrState, emr_state: State.name, emrcities: cities, selectedEmrCity: '' });
	};

	handleEmrCityChange = (e) => {
		this.setState({ selectedEmrCity: e.target.value, emr_city: e.target.value });
	};

	AddValuesModal = ({ id, heading, options, disabledOptions, onSubmit }) => {
		const filterOptions = createFilterOptions({
			matchFrom: 'start',
			stringify: option => option.name,
		});

		const [selected, setSelected] = useState([]);
		const [loading, setLoading] = useState(false);
		const [error, setError] = useState('');
		const dismissRef = useRef(null);

		const handleOpen = () => {
			setSelected([]);
			setError('');
			setLoading(false);
		}

		const handleChange = (selectedList) => {
			setSelected(selectedList);
		}

		const handleSubmit = async () => {
			setLoading(true);

			if (selected.length <= 0) {
				setError('Please select at least one option');
				setLoading(false);
				return;
			}
			
			const resp = await onSubmit(selected);

			if (resp && resp.code === 200) {
				setSelected([]);
				setError('');
				if (dismissRef && dismissRef.current) {
					dismissRef.current.click();
				}
			} else {
				setError(resp && resp.message || 'Something went wrong');
			}
			setLoading(false);
		}

		return (
			<React.Fragment>
				{
					this.state.hr_permission == 'yes' && (
						<div class="addBtn" data-toggle="modal" data-target={`#${id}`} onClick={() => handleOpen()}>
							<i class="far fa-plus"></i>
						</div>
					)
				}
				<div class="modal fade in" id={id} tabindex="-1" role="dialog" aria-labelledby={id} aria-hidden="true">
					<div class="modal-dialog modal-dialog-centered modal-dialog modal-md" role="document">
						<div class="modal-content">
							<div class="modal-header">
								<h4 class="modal-title">{heading}</h4>
								<button type="button" class="close" data-dismiss="modal">×</button>
							</div>
							<div class="modal-body row">
								<div class="mt-3 float-left popup_tag_area">
									<form>
										<div class="form-group row">
											<div class="col-sm-12">
												<div>
													{(options || []).length > 0 ?
														<CustomAutocomplete
															multiple
															options={options || []}
															groupBy={(id != "AddPermissions" && id != "AddPermissionsEdit" ) ? (option) => option.group_type_name || 'Other' : null}
															getOptionLabel={(option) => option.name}
															onChange={(event , value) => handleChange(value)}
															getOptionDisabled={(option) => !! disabledOptions.find(element => element.id === option.id)}
															value={selected}
															filterOptions={filterOptions}
															filterSelectedOptions
															renderGroup={(params) => (
																<div key={params.key}>
																	<div style={{ 
																		fontWeight: 'bold', 
																		padding: '8px 16px', 
																		backgroundColor: '#f5f5f5',
																		borderBottom: '1px solid #ddd',
																		textTransform: 'capitalize'
																	}}>
																		{params.group}
																	</div>
																	{params.children}
																</div>
															)}
															renderInput={(params) => (
																<TextField
																	{...params}
																	variant="outlined"
																	// label="Users Names"
																	placeholder="Select"
																/>
																)}
														/> :''}
												</div>
											</div>
										</div>
										<span class="error ml-10">{error}</span>
									</form>
								</div>
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-secondary" data-dismiss="modal">Dismiss</button>
								{loading ? (
									<button type="submit" class="btn btn-sky disabled" >
										<div>
											<i class="fa fa-spinner fa-spin"></i>
											<span>Adding</span>
										</div>
									</button>
								) : (
									<button type="button" class="btn btn-sky" onClick={() => handleSubmit()}>Add</button>
								)}
								<button ref={dismissRef} type="button" data-dismiss="modal" class="hide" id="dismiss2"></button>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}

	DeleteConfirmationModal = ({ id, message, onConfirm }) => {
		const dismissRef = useRef(null);
		const [loading, setLoading] = useState(false);

		const handleConfirm = async () => {
			setLoading(true);
			await onConfirm();
			if (dismissRef && dismissRef.current) {
				dismissRef.current.click();
			}
			setLoading(false);
		}

		return (
			<div className="modal fade" id={id} tabIndex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-hidden="true">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-body">
							<div className="icon_txt">
							{message}
							</div>
							<p className="mt20 pull-right">
								<button disabled={loading} className="btn btn-blue" data-dismiss="modal">Cancel</button>
								<button disabled={loading} data-dismiss="modal" type="button" class="btn btn-sky" onClick={() => handleConfirm()}>
									{loading ? (
										<div style={{ display: 'flex', alignItems: 'center' }}>
											<i class="fa fa-spinner fa-spin"></i>
											<span>Removing</span>
										</div>
									) : 'Remove'}
								</button>
							</p>
							<button ref={dismissRef} type="button" data-dismiss="modal" class="hide" id="dismiss2"></button>
							<div class="clear"></div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	// ER:116571

	render() {
		if (this.state.redirect) {
			return (
				<Redirect to={'/login'} />
			)
		}
		const filterOptions = createFilterOptions({
			matchFrom: 'start',
			stringify: option => option.name,
		});
		return (
			<div>
				<Header brecum_name="Employee" brecum_page="Add Employee" />
				<div class="right_col" role="main">
					{/* <div class="loader-new"></div> */}
					<div class="intranet_body">
						<div class="title mob hidden-md"><HeaderMob page_name="Add Employee" /></div>
						<div class="title">
							<span>Job Information</span>
						</div>
						<div class="row intra_form top emp_info_img">
							<div id="image-preview">
								<input type="file" name="imgInp" id="imgInp" ref={c => this.imgInp = c} />
								<img id="blah" src={Profile_img} alt="your image" />
								<i class="fa fa-cloud-upload-alt"></i>
							</div>
							<div class="empolyee_info">
								<div class="form-group row">
									<label for="name" class="col-sm-3 col-form-label">Name<span class="star">*</span></label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="name" placeholder="Name" class="form-control" onChange={this.onChange} />
										<span class="error">{this.state.errors["name"]}</span>
									</div>
								</div>
								<div class="form-group row">
									<label for="position" class="col-sm-3 col-form-label">Designation<span class="star">*</span></label>
									<div class="col-sm-9 col-xs-12">
										<select class="form-control" name="position" onChange={this.onChange}>
											<option value="0">Select Position</option>
											{
												this.props.hiring_profile.map((hiring_profile, key) =>
													<option value={hiring_profile.name}>{hiring_profile.name}</option>
												)
											}
										</select>
										<span class="error">{this.state.errors["position"]}</span>
									</div>
								</div>
								<div class="form-group row">
									<label for="linkedin_url" class="col-sm-3 col-form-label">LinkedIn URL<span class="star">*</span></label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="linkedin_url" placeholder="LinkedIn URL" class="form-control" onChange={this.onChange} />
										<span class="error">{this.state.errors["linkedin_url"]}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="row intra_form emp_mob">
							<div class="col-md-6 col-xs-12">
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Employee ID</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="muvi_employee_id" class="form-control" value={this.state.fields['muvi_employee_id']} onChange={this.onChange} />
										<span class="error">{this.state.errors["muvi_employee_id"]}</span>
										{
											!this.state.errors["muvi_employee_id"] && <span class="error">{this.props.registered_emp_id}</span>
										}
									</div>
								</div>
								<div class="form-group row" style={{ height: '38px' }}>
									<label for="staticEmail" class="col-sm-3 col-form-label">Career started with MUVI on</label>
									<div class="col-sm-9 col-xs-12">
										<DatePicker
											onKeyDown={e => e.preventDefault()}
											selected={this.state.date_of_joining}
											dateFormat="dd/MM/yyyy"
											onChange={this.handleChangeDateOfJoining}
										/>
									</div>
								</div>
								<div class="form-group row">
									<label for="inputPassword" class="col-sm-3 col-form-label">Permission<span class="star">*</span></label>
									<div class="col-sm-9 col-xs-12">
										{this.state.selected_permission != '' && this.state.selected_permission.map((permission, i) => {
											return <div class="mab-bootstrap-taginput-tag">{permission.name}
												<React.Fragment>
													<div class="" data-toggle="modal" data-target={`#deletePermissionModal${permission.id}`}>
														<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"
															><path d="M12.25 4.25L4.25 12.25" stroke="#5A738E" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M4.25 4.25L12.25 12.25" stroke="#888888" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
														</svg>
													</div>
													<this.DeleteConfirmationModal
														id={`deletePermissionModal${permission.id}`}
														message={`Are you sure want to remove the permission ${permission.name}?`}
														onConfirm={() => this.ClosePermission(permission)}
													/>
												</React.Fragment>
											</div>
										})}
										<this.AddValuesModal
											id="AddPermissions"
											heading="Add Permissions"
											options={this.props.permissions}
											disabledOptions={this.state.selected_permission}
											onSubmit={this.addPermissions}
										/>
										<span class="error">{this.state.errors["project"]}</span>
									</div>
								</div>
								{/* <div class="form-group row" >
									<label for="staticEmail" class="col-sm-3 col-form-label"></label>
									<div class="col-xs-6 col-sm-6 col-md-8 col-lg-8">
										<div>
											{this.state.selected_permission != '' && this.state.selected_permission.map((permission, i) => {
												return <div class="mab-bootstrap-taginput-tag">{permission.name}
													<React.Fragment>
														<div class="" data-toggle="modal" data-target={`#deletePermissionModal${permission.id}`}>
															<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"
																><path d="M12.25 4.25L4.25 12.25" stroke="#5A738E" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M4.25 4.25L12.25 12.25" stroke="#888888" stroke-opacity="0.6" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
															</svg>
														</div>
														<this.DeleteConfirmationModal
															id={`deletePermissionModal${permission.id}`}
															message={`Are you sure want to remove the permission ${permission.name}?`}
															onConfirm={() => this.ClosePermission(permission)}
														/>
													</React.Fragment>
												</div>
											})}
										</div>
									</div>
								</div> */}
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Level<span class="star">*</span></label>
									<div class="col-sm-9 col-xs-12">
										<select class="form-control" placeholder="Select Level" name="emp_level" onChange={this.onChange}>
											<option value="">Select Level</option>
											<option value="R1">R1</option>
											<option value="R2">R2</option>
											<option value="R3">R3</option>
											<option value="R4">R4</option>
											<option value="R5">R5</option>
											<option value="R6">R6</option>
											<option value="R7">R7</option>
											<option value="R8">R8</option>
											<option value="R9">R9</option>
										</select>
										<span class="error">{this.state.errors["emp_level"]}</span>
									</div>
								</div>
								<div class="form-group row" >
									<label for="staticEmail" class="col-sm-3 col-form-label"></label>
									<div class="col-xs-6 col-sm-6 col-md-8 col-lg-8">
										<span class="error">{this.props.registred_member}</span>
									</div>
								</div>
							</div>
							<div class="col-md-6 col-xs-12">
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Email ID<span class="star">*</span></label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="email" placeholder="Enter Email Id" class="form-control" onChange={this.onChange} />
										<span class="error">{this.props.registered_mail}</span>
										<span class="error">{this.state.errors["email"]}</span>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Manager<span class="star">*</span></label>
									<div class="col-sm-9 col-xs-12">

										<div class="filter" name="manager">
											<MuiThemeProvider muiTheme={getMuiTheme()} class="form-control">
												<AutoComplete
													onUpdateInput={this.handleUpdateInput_manager}
													onNewRequest={this.onNewRequest_manager.bind(this)}
													onClick={this.handleUpdateInput_manager}
													fullWidth={true}
													placeholder="Type here to manager Name"
													filter={AutoComplete.caseInsensitiveFilter}
													dataSource={this.state.search}
													dataSourceConfig={dataSourceConfig}
													errorStyle={{ bottom: 0 }}
													errorText={this.state.errorText1}
													maxSearchResults={500}
													className="ticket_search_box"
													searchText={this.state.searchText1}
													openOnFocus={true}
													menuStyle={{ maxHeight: '160px' }}
												/>
											</MuiThemeProvider>
										</div>
										<span class="error">{this.state.errors["manager"]}</span>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Functional Lead</label>
									<div class="col-sm-9 col-xs-12">

										<div class="filter" name="func_manager">
											<MuiThemeProvider muiTheme={getMuiTheme()} class="form-control">
												<AutoComplete
													onUpdateInput={this.handleUpdateInput_func_manager}
													onNewRequest={this.onNewRequest_func_manager.bind(this)}
													onClick={this.handleUpdateInput_func_manager}
													fullWidth={true}
													placeholder="Type here to functional lead Name"
													filter={AutoComplete.caseInsensitiveFilter}
													dataSource={this.state.search}
													dataSourceConfig={dataSourceConfig}
													errorStyle={{ bottom: 0 }}
													errorText={this.state.errorText2}
													maxSearchResults={500}
													className="ticket_search_box"
													searchText={this.state.searchText2}
													openOnFocus={true}
													menuStyle={{ maxHeight: '160px' }}
												/>
											</MuiThemeProvider>
										</div>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Work Location</label>
									<div class="col-sm-9 col-xs-12">
										<select class="form-control" placeholder="Select Location" name="worklocation" onChange={this.onChange}>
											<option value="">Select Work Location</option>
											<option value="Remote">Remote</option>
											<option value="Onsite">Onsite</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Add Snippet</label>
									<div class="col-sm-9 col-xs-12 radio_custom">
										<div class="radio-inline feature-check">
											<input class="valid_fld" id="snippet1" value="0" type="radio" name="snippet" onChange={this.onChange} />
											<label for="snippet1"><span></span>Optional</label>
										</div>
										<div class="radio-inline feature-check">
											<input class="valid_fld" id="snippet2" value="1" type="radio" name="snippet" onChange={this.onChange} checked="true" />
											<label for="snippet2"><span></span>Mandatory</label>
										</div>
									</div>
								</div>
							</div>
						</div>
						<hr />
						<div class="title">
							<span>Personal Information</span>
						</div>
						<div class="row intra_form emp_mob">
							<div class="col-md-6 col-xs-12">
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Personal Email ID</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="per_email" placeholder="Enter Email Id" class="form-control" onChange={this.onChange} />
										<span class="error">{this.state.errors["per_email"]}</span>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Address Line 1</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="per_address_1" placeholder="Enter Address Line 1" class="form-control" onChange={this.onChange} />
										<span class="error">{this.state.errors["per_address_1"]}</span>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">Country</label>
									<div className="col-sm-9 col-xs-12">
										<select className="form-control" value={this.state.selectedCountry} onChange={this.handleCountryChange}>
											<option value="">Select Country</option>
											{this.state.countries.map(country => (
												<option key={country.iso2} value={country.iso2} name={country.name}>
													{country.name}
												</option>
											))}
										</select>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">City</label>
									<div className="col-sm-9 col-xs-12">
										<select className="form-control" value={this.state.selectedCity} onChange={this.handleCityChange} disabled={!this.state.selectedState}>
											<option value="">Select City</option>
											{this.state.cities.map(city => (
												<option key={city.id} value={city.name}>
													{city.name}
												</option>
											))}
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Phone Number</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="per_phoneno" class="form-control" placeholder="Enter Phone No" onChange={this.onChange} />
										<span class="error">{this.state.errors["per_phoneno"]}</span>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Date Of Birth</label>
									<div class="col-sm-9 col-xs-12" name="date_of_birth">
										<DatePicker
											onKeyDown={e => e.preventDefault()}
											selected={this.state.dateofBirth}
											onChange={this.handleChangeDateOfBirth}
											peekNextMonth
											showMonthDropdown
											showYearDropdown
											dropdownMode="select"
											dateFormat="dd/MM/yyyy"
										/>
										<span class="error">{this.state.errors["date_of_birth"]}</span>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Highest Qualification</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="qualification" placeholder="Highest Qualification" class="form-control" onChange={this.onChange} />
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Technical Skill</label>
									<div class="col-sm-9 col-xs-12">
										<textarea type="text" name="skill" placeholder="Enter Technical Skill" class="form-control" onChange={this.onChange}></textarea>
									</div>
								</div>
							</div>
							<div class="col-md-6 col-xs-12">
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Gender</label>
									<div class="col-sm-9 col-xs-12 radio_custom">
										<div class="radio-inline feature-check">
											<input class="valid_fld" id="gender1" value="1" type="radio" name="gender" onChange={this.onChange} />
											<label for="gender1"><span></span>Male</label>
										</div>
										<div class="radio-inline feature-check">
											<input class="valid_fld" id="gender2" value="2" type="radio" name="gender" onChange={this.onChange} />
											<label for="gender2"><span></span>Female</label>
										</div><br />
										<span class="error">{this.state.errors["gender"]}</span>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Address Line2</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="per_address_2" class="form-control" placeholder="Enter Address Line2" onChange={this.onChange} />
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">State</label>
									<div className="col-sm-9 col-xs-12">
										<select className="form-control" value={this.state.selectedState} onChange={this.handleStateChange} disabled={!this.state.selectedCountry}>
											<option value="">Select State</option>
											{this.state.states.map(state => (
												<option key={state.iso2} value={state.iso2} name={state.name}>
													{state.name}
												</option>
											))}
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Zip Code</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="per_zipcode" placeholder="Enter Zip Code" class="form-control" onChange={this.onChange} />
										<span class="error">{this.state.errors["per_zipcode"]}</span>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Marital Status</label>
									<div class="form-group col-sm-9 col-xs-12">
										<select class="form-control" name="marital_status" onChange={this.onChange}>
											<option value="">Select</option>
											<option value="Married">Married</option>
											<option value="Single">Single</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Religion</label>
									<div class="form-group col-sm-9 col-xs-12">
										<select class="form-control" name="religion" onChange={this.onChange}>
											<option value="">Select</option>
											<option value="Hindu">Hindu</option>
											<option value="Muslim">Muslim</option>
											<option value="Sikh">Sikh</option>
											<option value="Christian">Christian</option>
											<option value="Jain">Jain</option>
											<option value="Buddhist">Buddhist</option>
											<option value="Prefer not to disclose">Prefer not to disclose</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Language Known</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="language" class="form-control" placeholder="Enter Language" onChange={this.onChange} />
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Interest & Hobbies</label>
									<div class="col-sm-9 col-xs-12">
										<textarea type="text" name="interest_hobbies" placeholder="Enter Interest & Hobbies" class="form-control" onChange={this.onChange}></textarea>
									</div>
								</div>
							</div>
						</div>
						<hr />
						<div class="title">
							<span>Confidential Information</span>
						</div>
						<div class="row intra_form emp_mob">
							<div class="col-md-6 col-xs-12">
								<div class="form-group row perso_upload">
									<label for="staticEmail" class="col-sm-3 col-form-label">PAN Number</label>
									<div class="col-sm-7 col-xs-12">
										<input type="text" name="pan" class="form-control" placeholder="Enter PAN Number" onChange={this.onChange} />
										<span class="perso_text"></span>
									</div>
									<div class="col-sm-2 col-xs-12">
										<div class="perso_id">
											<input type="file" class="inputfile" id="pan_img" accept=".png, .jpg, .jpeg, .pdf" ref={c => this.pan_img = c} />
											<i class="fal fa-cloud-upload"></i>
										</div>
									</div>
								</div>
								<div class="form-group row perso_upload">
									<label for="inputPassword" class="col-sm-3 col-form-label">Passport Number</label>
									<div class="col-sm-7 col-xs-12">
										<input type="text" class="form-control" name="passport" placeholder="Enter Passport Number" onChange={this.onChange} />
										<span class="perso_text"></span>
									</div>
									<div class="col-sm-2 col-xs-12">
										<div class="perso_id">
											<input type="file" id="passport_img" accept=".png, .jpg, .jpeg, .pdf" ref={c => this.passport_img = c} />
											<i class="fal fa-cloud-upload"></i>
										</div>
									</div>
								</div>
								<div class="form-group row perso_upload">
									<label for="staticEmail" class="col-sm-3 col-form-label">Aadhar Number</label>
									<div class="col-sm-7 col-xs-12">
										<input type="text" name="adhaar" class="form-control" placeholder="Enter Aadhar Number" onChange={this.onChange} />
										<span class="perso_text"></span>
									</div>
									<div class="col-sm-2 col-xs-12">
										<div class="perso_id">
											<input type="file" id="adhar_img" accept=".png, .jpg, .jpeg, .pdf" ref={c => this.adhar_img = c} />
											<i class="fal fa-cloud-upload"></i>
										</div>
									</div>

								</div>
							</div>
							<div class="col-md-6 col-xs-12">
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Blood Group</label>
									<div class="col-sm-9 col-xs-12">
										<select class="form-control" name="blood_group" onChange={this.onChange}>
											<option value="">Enter Blood Group</option>
											<option value="A+">A+</option>
											<option value="A-">A-</option>
											<option value="B+">B+</option>
											<option value="B-">B-</option>
											<option value="O+">O+</option>
											<option value="O-">O-</option>
											<option value="AB+">AB+</option>
											<option value="AB-">AB-</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Hierarchy Level</label>
									<div class="form-group col-sm-9 col-xs-12">
										<select class="form-control" name="hierarchy_level" onChange={this.onChange}>
											<option value="">Select</option>
											<option value="1">1</option>
											<option value="2">2</option>
											<option value="3">3</option>
											<option value="4">4</option>
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">ESOP</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="emr_esop" class="form-control" placeholder="Enter ESOP" onChange={this.onChange} />
									</div>
								</div>
							</div>
						</div>
						<hr />
						<div class="title">
							<span>Emergency Contact Information</span>
						</div>
						<div class="row intra_form emp_mob">
							<div class="col-md-6 col-xs-12">
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Name</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="emr_name" class="form-control" placeholder="Enter Name" onChange={this.onChange} />
										<span class="error">{this.state.errors["emr_name"]}</span>
									</div>
								</div>
								<div class="form-group row">
									<label for="inputPassword" class="col-sm-3 col-form-label">Address</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" class="form-control" name="emr_address" placeholder="Enter Address" onChange={this.onChange} />
										<span class="error">{this.state.errors["emr_address"]}</span>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">State</label>
									<div className="col-sm-9 col-xs-12">
										<select className="form-control" value={this.state.selectedEmrState} onChange={this.handleEmrStateChange} disabled={!this.state.selectedEmrCountry} name={'selectedEmrState'}>
											<option value="">Select State</option>
											{this.state.emrstates.map(state => (
												<option key={state.iso2} value={state.iso2} >
													{state.name}
												</option>
											))}
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Zip Code</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="emr_zipcode" class="form-control" placeholder="Enter Zip Code" onChange={this.onChange} />
										<span class="error">{this.state.errors["emr_zipcode"]}</span>
									</div>
								</div>
							</div>
							<div class="col-md-6 col-xs-12">
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Relationship</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="emr_relationship" class="form-control" placeholder="Enter Relationship" onChange={this.onChange} />
										<span class="error">{this.state.errors["emr_relationship"]}</span>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">Country</label>
									<div className="col-sm-9 col-xs-12">
										<select className="form-control" value={this.state.selectedEmrCountry} onChange={this.handleEmrCountryChange} name={'selectedEmrCountry'}>
											<option value="">Select Country</option>
											{this.state.emrcountries.map(country => (
												<option key={country.iso2} value={country.iso2} >
													{country.name}
												</option>
											))}
										</select>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-sm-3 col-form-label">City</label>
									<div className="col-sm-9 col-xs-12">
										<select className="form-control" value={this.state.selectedEmrCity} onChange={this.handleEmrCityChange} disabled={!this.state.selectedEmrState} name={'selectedEmrCity'}>
											<option value="">Select City</option>
											{this.state.emrcities.map(city => (
												<option key={city.id} value={city.name} >
													{city.name}
												</option>
											))}
										</select>
									</div>
								</div>
								<div class="form-group row">
									<label for="staticEmail" class="col-sm-3 col-form-label">Phone Number</label>
									<div class="col-sm-9 col-xs-12">
										<input type="text" name="emr_phone_no" class="form-control" placeholder="Enter Phone Number" onChange={this.onChange} />
										<span class="error">{this.state.errors["emr_phone_no"]}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="intra_form">
							<button type="submit" name="add_employee" id="add_employee" class="btn btn-sky mob-btn" onClick={() => this.insertEmployee()}>Submit</button>
							<Link to={`/employees/`} name={"max"}> <button className="btn btn-blue hidden-sm" >Back</button></Link>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
const mapStateToProps = (state) => {
	return {
		// department_names: state.mEmRe.department_names,
		// pod_names: state.mEmRe.pod_names,
	// crop_names: state.mEmRe.crop_names,
		// email_names: state.mEmRe.email_names,
		// troop_names: state.mEmRe.troop_names,
		emp_id: state.mEmRe.emp_id,
		employee_id: state.mEmRe.employee_id,
		hiring_profile: state.mEmRe.hiring_profile,
		permissions: state.mEmRe.permissions,
		// email_groups: state.mEmRe.email_groups,
		// pod: state.mEmRe.pod,
		loading: state.mEmRe.loading,
		registred_member: state.addEmpRed.registred_member,
		registered_mail: state.addEmpRed.registered_mail,
		registered_emp_id: state.addEmpRed.registered_emp_id,
		submit_sucsess: state.addEmpRed.submit_sucsess
	}
}
const mapDispatchToProps = {
	//   userList,
	insertEmployee,
	getDefaultData
}
export default connect(mapStateToProps, mapDispatchToProps)(AddEmployee);
//export default AddEmployee;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/addEmployee.js